import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'card-body', // tslint:disable-line
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardBodyComponent {}
